<style lang="less" scoped>
.ai-markdown-stream-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.ai-markdown-stream-toolbar {
  flex-shrink: 0;
  padding-bottom: 8px;
}
.ai-markdown-stream-body {
  flex: 1;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 28px 32px 32px;
  background: #fff;
  border: 1px solid var(--border);
  position: relative;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
.ai-markdown-stream-raw {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 15px;
  line-height: 1.75;
  color: #1e293b;
  font-family: inherit;
}
.ai-markdown-stream-report-live {
  min-height: 0;
}
.ai-markdown-stream-live-md /deep/ .base-markdown-view--plain {
  padding: 0;
  border: none;
  min-height: 0;
}
/* Markdown 区域不出现横向滚动，长行自动换行 */
.ai-markdown-stream-body /deep/ .mdmdt {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.75;
  font-size: 15px;
  color: #1e293b;
}
/* 正文段落：首行缩进 + 略宽行距（列表/引用内段落不缩进） */
.ai-markdown-stream-body /deep/ .mdmdt p {
  text-indent: 2em;
  line-height: 1.8;
  margin: 0.65em 0;
}
.ai-markdown-stream-body /deep/ .mdmdt li p {
  text-indent: 0;
  margin: 0.35em 0;
  line-height: 1.75;
}
.ai-markdown-stream-body /deep/ .mdmdt h1,
.ai-markdown-stream-body /deep/ .mdmdt h2,
.ai-markdown-stream-body /deep/ .mdmdt h3,
.ai-markdown-stream-body /deep/ .mdmdt h4,
.ai-markdown-stream-body /deep/ .mdmdt h5,
.ai-markdown-stream-body /deep/ .mdmdt h6 {
  text-indent: 0;
  text-align: left !important;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
  margin-top: 1.15em;
  margin-bottom: 0.45em;
}
.ai-markdown-stream-body /deep/ .mdmdt h1 {
  font-size: 1.5rem;
  font-weight: 700;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.35em;
}
.ai-markdown-stream-body /deep/ .mdmdt h2 {
  font-size: 1.3rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h3 {
  font-size: 1.15rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h4 {
  font-size: 1.05rem;
}
.ai-markdown-stream-body /deep/ .mdmdt h5,
.ai-markdown-stream-body /deep/ .mdmdt h6 {
  font-size: 1rem;
  font-weight: 600;
}
.ai-markdown-stream-body /deep/ .mdmdt hr + p,
.ai-markdown-stream-body /deep/ .mdmdt h1 + p,
.ai-markdown-stream-body /deep/ .mdmdt h2 + p,
.ai-markdown-stream-body /deep/ .mdmdt h3 + p {
  margin-top: 0.75em;
}
.ai-markdown-stream-body /deep/ .mdmdt ul,
.ai-markdown-stream-body /deep/ .mdmdt ol {
  line-height: 1.75;
  padding-left: 1.5em;
}
.ai-markdown-stream-body /deep/ .mdmdt blockquote {
  line-height: 1.75;
}
.ai-markdown-stream-body /deep/ .mdmdt blockquote p {
  text-indent: 0;
}
.ai-markdown-stream-body /deep/ .mdmdt pre {
  text-indent: 0;
  line-height: 1.5;
}
.ai-markdown-stream-body /deep/ .mdmdt pre,
.ai-markdown-stream-body /deep/ .mdmdt code {
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 100%;
}
.ai-markdown-stream-body /deep/ .mdmdt img,
.ai-markdown-stream-body /deep/ .mdmdt video {
  max-width: 100%;
  height: auto;
}
.ai-markdown-stream-body /deep/ .mdmdt table {
  width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
}
.ai-markdown-stream-body /deep/ .mdmdt th,
.ai-markdown-stream-body /deep/ .mdmdt td {
  word-break: break-word;
}
.ai-markdown-placeholder {
  color: #999;
  padding: 32px 16px;
  text-align: center;
  line-height: 1.6;
}
.ai-markdown-streaming-tip {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 2;
  font-size: 12px;
  color: var(--primary, #2d8cf0);
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--border);
}
.ai-markdown-stream-thinking {
  margin-bottom: 16px;
  padding: 10px 12px 12px;
  background: linear-gradient(180deg, #f0f7ff 0%, #f8fafc 100%);
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}
.ai-markdown-stream-thinking-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 8px;
  user-select: none;
}
.ai-markdown-stream-thinking-note {
  font-weight: 400;
  color: #64748b;
}
.ai-markdown-stream-thinking-scroll {
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
}
.ai-markdown-stream-thinking.is-done .ai-markdown-stream-thinking-scroll {
  max-height: 160px;
}
.ai-markdown-stream-thinking-body {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.65;
  color: #475569;
}
.ai-markdown-stream-report-raw {
  margin: 0;
}
</style>
<template>
  <div class="ai-markdown-stream-panel">
    <div v-if="$slots.toolbar" class="ai-markdown-stream-toolbar">
      <slot name="toolbar" />
    </div>
    <div ref="scrollBody" class="ai-markdown-stream-body pdf-export">
      <div v-if="isLiveStream" class="ai-markdown-streaming-tip">
        正在生成…
        <span v-if="thinkingText.length">（思考 {{ thinkingText.length }} 字）</span>
        <span v-if="streamText.length">（正文 {{ streamText.length }} 字）</span>
      </div>
      <div v-if="showPlaceholder" class="ai-markdown-placeholder">
        {{ placeholder }}
      </div>
      <!-- 思考过程：仅展示，不含入报告 / PDF / 复制 -->
      <div
        v-show="thinkingText"
        class="ai-markdown-stream-thinking pdf-exclude"
        :class="{ 'is-done': !isLiveStream }"
      >
        <div class="ai-markdown-stream-thinking-label">
          <Icon type="ios-bulb-outline" />
          思考过程
          <span class="ai-markdown-stream-thinking-note">（不含入报告 · 请用中文思考）</span>
        </div>
        <div ref="thinkingScroll" class="ai-markdown-stream-thinking-scroll" @scroll="onThinkingScroll">
          <pre ref="thinkingPre" class="ai-markdown-stream-thinking-body">{{ thinkingText }}</pre>
        </div>
      </div>
      <!-- 流式正文：单块 Markdown 节流更新，避免多段渲染间距过大 -->
      <div v-show="isLiveStream && streamLiveMarkdown" class="ai-markdown-stream-report-live">
        <BaseMarkdownView
          ref="liveMarkdown"
          class="ai-markdown-stream-live-md"
          :value="streamLiveMarkdown"
          plain
        />
      </div>
      <BaseMarkdownView
        v-show="!isLiveStream && !showPlaceholder"
        ref="content"
        :value="value"
      />
    </div>
  </div>
</template>

<script>
const LIVE_MARKDOWN_THROTTLE_MS = 200;
/** 距底部多少 px 内视为「在底部」，恢复自动跟随 */
const THINKING_SCROLL_BOTTOM_THRESHOLD = 24;

export default {
  name: 'AiMarkdownStreamPanel',
  props: {
    value: {
      type: String,
      default: '',
    },
    streaming: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '选择提示词后点击「生成报告」，流式结果将显示在此。',
    },
  },
  data() {
    return {
      streamText: '',
      thinkingText: '',
      streamLiveMarkdown: '',
      /** 父组件 beginStream() 立即进入流式 UI，不等待 prop 传递 */
      liveStreaming: false,
      /** 思考区是否自动滚到底（用户手动滚动后暂停） */
      thinkingAutoScroll: true,
      _thinkingProgrammaticScroll: false,
      _liveMarkdownTimer: null,
      _pendingLiveMarkdown: '',
    };
  },
  computed: {
    isLiveStream() {
      return this.streaming || this.liveStreaming;
    },
    showPlaceholder() {
      return !this.isLiveStream && !(this.value && String(this.value).trim());
    },
  },
  watch: {
    value(v) {
      if (!this.isLiveStream) {
        this.streamText = v || '';
      }
    },
    streaming(v) {
      if (!v) {
        this.liveStreaming = false;
        this.streamText = this.value || '';
        this._clearLiveMarkdownTimer();
        this.$nextTick(() => this.scrollReportToBottom());
      }
    },
  },
  beforeDestroy() {
    this._clearLiveMarkdownTimer();
  },
  methods: {
    beginStream() {
      this.liveStreaming = true;
      this.streamText = '';
      this.thinkingText = '';
      this.streamLiveMarkdown = '';
      this._pendingLiveMarkdown = '';
      this.thinkingAutoScroll = true;
      this._thinkingProgrammaticScroll = false;
      this._clearLiveMarkdownTimer();
      this.$nextTick(() => {
        const thinking = this.$refs.thinkingPre;
        if (thinking) thinking.textContent = '';
        this.scrollThinkingToBottom();
      });
    },
    endStream(finalText) {
      this.liveStreaming = false;
      this._clearLiveMarkdownTimer();
      if (finalText != null) {
        this.streamText = String(finalText);
      }
      this.streamLiveMarkdown = '';
    },
    /** 流式：分别更新思考过程与正文 */
    setStreamState(state) {
      const content = state && state.content != null ? String(state.content) : '';
      const reasoning = state && state.reasoning != null ? String(state.reasoning) : '';
      const reasoningChanged = reasoning !== this.thinkingText;
      const contentChanged = content !== this.streamText;

      this.streamText = content;
      this.thinkingText = reasoning;

      if (contentChanged) {
        this._scheduleLiveMarkdown(content);
      }

      if (reasoningChanged) {
        this._writeStreamDom('thinkingPre', reasoning);
        this.$nextTick(() => this.scrollThinkingToBottom());
      }

      if (contentChanged) {
        this.$nextTick(() => this.scrollReportToBottom());
      }
    },
    /** @deprecated 兼容旧调用，仅更新正文 */
    setStreamText(text) {
      this.setStreamState({ content: text == null ? '' : String(text), reasoning: this.thinkingText });
    },
    _scheduleLiveMarkdown(content) {
      this._pendingLiveMarkdown = content;
      if (!content) {
        this.streamLiveMarkdown = '';
        this._clearLiveMarkdownTimer();
        return;
      }
      // 首段内容立即渲染，后续节流避免卡顿
      if (!this.streamLiveMarkdown) {
        this.streamLiveMarkdown = content;
        return;
      }
      if (this._liveMarkdownTimer) return;
      this._liveMarkdownTimer = setTimeout(() => {
        this._liveMarkdownTimer = null;
        this.streamLiveMarkdown = this._pendingLiveMarkdown;
        this.$nextTick(() => this.scrollReportToBottom());
      }, LIVE_MARKDOWN_THROTTLE_MS);
    },
    _flushLiveMarkdown() {
      this._clearLiveMarkdownTimer();
      if (this._pendingLiveMarkdown) {
        this.streamLiveMarkdown = this._pendingLiveMarkdown;
      }
    },
    _clearLiveMarkdownTimer() {
      if (this._liveMarkdownTimer) {
        clearTimeout(this._liveMarkdownTimer);
        this._liveMarkdownTimer = null;
      }
    },
    _writeStreamDom(refName, text) {
      const apply = () => {
        const el = this.$refs[refName];
        if (el && el.textContent !== text) {
          el.textContent = text;
        }
      };
      apply();
      if (!this.$refs[refName]) {
        this.$nextTick(apply);
      }
    },
    getPdfElement() {
      if (this.$refs.content && this.$refs.content.$el) {
        return this.$refs.content.$el;
      }
      return this.$refs.scrollBody;
    },
    isThinkingAtBottom() {
      const scroll = this.$refs.thinkingScroll;
      if (!scroll) return true;
      return scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight <= THINKING_SCROLL_BOTTOM_THRESHOLD;
    },
    onThinkingScroll() {
      if (this._thinkingProgrammaticScroll) return;
      this.thinkingAutoScroll = this.isThinkingAtBottom();
    },
    scrollThinkingToBottom() {
      if (!this.thinkingAutoScroll) return;
      const scroll = this.$refs.thinkingScroll;
      if (!scroll) return;
      this._thinkingProgrammaticScroll = true;
      scroll.scrollTop = scroll.scrollHeight;
      requestAnimationFrame(() => {
        this._thinkingProgrammaticScroll = false;
      });
    },
    scrollReportToBottom() {
      const el = this.$refs.scrollBody;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    scrollToBottom() {
      this.scrollThinkingToBottom();
      this.scrollReportToBottom();
    },
  },
};
</script>
